/**
 * I colori dei tipi di documento, uguali in Fatture e in Passività: il bordo
 * della riga, la striscia a sinistra, la scritta del tipo e il tasto che
 * filtra quel tipo hanno lo stesso colore. Scelti ben diversi fra loro.
 *
 * Le classi sono scritte per intero perche' Tailwind le trovi nel codice.
 */
export const COLORI = {
  blu: {
    bordo: 'border-blue-400',
    barra: 'bg-blue-500',
    testo: 'text-blue-700',
    spento: 'border-blue-400 bg-white text-blue-700 hover:bg-blue-50',
    acceso: 'border-blue-500 bg-blue-500 text-white hover:bg-blue-600',
  },
  rosso: {
    bordo: 'border-red-400',
    barra: 'bg-red-500',
    testo: 'text-red-700',
    spento: 'border-red-400 bg-white text-red-700 hover:bg-red-50',
    acceso: 'border-red-500 bg-red-500 text-white hover:bg-red-600',
  },
  ambra: {
    bordo: 'border-amber-400',
    barra: 'bg-amber-500',
    testo: 'text-amber-700',
    spento: 'border-amber-400 bg-white text-amber-700 hover:bg-amber-50',
    acceso: 'border-amber-500 bg-amber-500 text-white hover:bg-amber-600',
  },
  viola: {
    bordo: 'border-violet-400',
    barra: 'bg-violet-500',
    testo: 'text-violet-700',
    spento: 'border-violet-400 bg-white text-violet-700 hover:bg-violet-50',
    acceso: 'border-violet-500 bg-violet-500 text-white hover:bg-violet-600',
  },
  grigio: {
    bordo: 'border-slate-300',
    barra: 'bg-slate-400',
    testo: 'text-slate-600',
    spento: 'border-slate-300 bg-white text-slate-600 hover:bg-slate-50',
    acceso: 'border-slate-500 bg-slate-500 text-white hover:bg-slate-600',
  },
} as const;

export type Colore = keyof typeof COLORI;

/** "1 fattura", "90 fatture". */
export const conta = (n: number, uno: string, tanti: string) => `${n} ${n === 1 ? uno : tanti}`;

/** Il meno davanti a un importo che si toglie (note di credito); niente se e' zero. */
export const segnoMeno = (n: number) => (n ? '−' : '');
